import s from './ImageInput.module.scss';
import ImageIcon from "../../assets/icons/image.svg";
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { FileManager } from 'components/FileManager/FileManager';
import { Checkbox } from '@mui/material';
import { isArray } from 'lodash';

export const ImageInput = ({values, setValues, type, styles, setIsManual, setDefault, disabled}: any) => {

    // ### State
    const langs = useSelector((store: any) => store.main.langs);
    const [storage, setStorage] = useState<boolean>(false)
    const [activeLang, setActiveLang] = useState(values?.isManual ? values?.default_image : langs?.[0].key)
    const [image, setImage] = useState(ImageIcon)

    // ### Effects
    useEffect(()=>{
        if(values?.isManual){
            setImage(values?.[activeLang] || ImageIcon)
        }
        else setImage(values?.[values.default_image] || values?.[activeLang] || ImageIcon)
    },[values, activeLang]);

    // ### Functions

    function changeValue(value: string){
        setValues({ [activeLang]: value })
        const check = langs?.filter((lang: any) => lang.key !== activeLang)?.find((lang: any) => values?.[lang.key])
        if(!check) setDefault(activeLang)
    }

    function changeDefault(value: string){
        setDefault(value)
    }

    // ### Views
   
    const langs_view = isArray(langs) ? langs?.map((el: any, index: number) => {
        const completed = values?.[el.key]?.length
        return(
            <div
                key={index}
                className={`${s.lang_item} ${activeLang === el.key? s.active_lang_item : ''} ${completed? s.completed_lang_item : ''}`}
                onClick={(e)=>{
                    setActiveLang(el.key)
                    e.stopPropagation()
                }}
            >
                <span className={s.key}>{el.key}</span>
                <span>{completed? <span>&#10004;</span> : <span>&#10008;</span>}</span>
                <input 
                    checked={values?.default_image === el.key}
                    type="checkbox" 
                    onClick={(e) => {
                        const check = values?.[el.key]
                        if(check){
                            changeDefault(el.key)
                            e.stopPropagation()
                        }
                    }}
                />
            </div>
        )
    }) : []

    
    return(
        <div 
            className={s.wpapper} 
            style={{
                ...styles
            }}
        >
            <div className={s.image_wrapper} onClick={() => !disabled && setStorage(true)}>
                {
                    type === "video" ?
                    <video src={image} controls/>:
                    <img src={image} alt="image" />
                }
                {
                    !disabled ? 
                    <div className={s.langs_wrapper}>
                        {values?.isManual ? langs_view : null}
                        <div className={s.multilingual}>
                            <Checkbox
                                checked={values?.isManual || false}
                                onClick={(e) => {
                                    setIsManual(!values?.isManual)
                                    e.stopPropagation()
                                }}
                            />
                            
                            <span>Manual</span>
                        </div>
                    </div> : null
                }
            </div>

            {
                storage ? 
                <FileManager 
                    isModal={true}
                    type={type || "image"}
                    setIsOpenStorage={() => setStorage(false)}
                    setFile={(link) => changeValue(link)}
                /> : null
            }
        </div>
    )
}